<template>
  <div>
    <!-- <div class="ban-img">
      <img src="https://static-cdn.app.99maiyou.com/ad/miluNarrower/1587044626.jpg" alt="无赦单职业">
    </div> -->

    <el-row :gutter="20">
      <el-col :span="18">
        <el-card shadow="never">
          <template slot="header">
            <span class="theme size16">所有资讯</span>
          </template>

          <new-list ref="nlist" />

          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="pageChange"
              :total="newList.length">
            </el-pagination>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="never">
          <template slot="header">
            <span class="theme size16">相关资讯</span>
          </template>

          <list />
        </el-card>

        <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">最新开服</span>
          </template>

          <hot-list />
        </el-card>

        <!-- <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">热门活动</span>
          </template>

          <list />
        </el-card> -->
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  data () {
    return {
      newList: this.$datas.newList,
      hotList: this.$datas.hotList,
      remList: this.$datas.remList,
    }
  },

  methods: {
    pageChange(e) {
      console.log(e);
      this.$refs.nlist.getData(e)
    }
  }
}
</script>

<style lang="scss">
.pagination {
  text-align: center;
  margin-top: 20px;
}  
</style>
